import axios from 'axios'
import {UserModel, AccountLoginModel} from '../models/UserModel'
import {API_URL} from '../../../../setup/helpers/apiUrl'

export const LOGIN_URL = `${API_URL}/Token`

export async function login(email: string, password: string) {
 console.log("Resp 14");
  // let loginObj:UserModel = {
  //   userName : email,
  //   password:password,
  //   Info:'',
  //   email:''
  // };    
  var querystring = require('querystring');

 console.log("Resp 21");
 console.log("Login url =>",LOGIN_URL);
//  console.log("login obj =>",loginObj);
 var resp;
  try{
    await axios.post(LOGIN_URL,querystring.stringify({
      username: email, 
      password: password,
      grant_type: 'password'
}),{headers:{ "Content-Type": "application/x-www-form-urlencoded"}})
    .then((response) =>{
      console.log("then =>", response);
      resp = response; 
    })
    .catch((err) => {
      console.log("thenCatch =>", err);
    });
    console.log("Response => ", resp);
    return resp;
  } 
  catch(err){
    console.log("login error =>", err);
    console.log("catch resp =>", resp);
    return err;
  }
}


